import React from 'react';

const TransactionImpressionsController = ({ children, impressions }) => {
  return React.cloneElement(children, {
    impressions,
  });
};

export default TransactionImpressionsController;
